import { render, staticRenderFns } from "./editperiods.vue?vue&type=template&id=3ef33ec1&scoped=true"
import script from "./editperiods.vue?vue&type=script&lang=js"
export * from "./editperiods.vue?vue&type=script&lang=js"
import style0 from "./editperiods.vue?vue&type=style&index=0&id=3ef33ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef33ec1",
  null
  
)

export default component.exports